// extracted by mini-css-extract-plugin
export var csatScore = "_nl-5";
export var header = "_nl-1";
export var panelWrapper = "_nl-2";
export var postPreview = "_nl-3";
export var rightContent = "_nl-0";
export var wrappingText = "_nl-4";